import React , { Component } from 'react';
import { Link } from 'react-router-dom';
import backImg from '../images/back.svg';


export default class MyInvestment extends Component {
    render(){
        return(
            <div className="container">
                <div className="row">
                    <div className="col-sm-12">
                    <div className="text-justify">
                        <Link to={"/investor"}><img src={ backImg } alt=""/></Link>
                    </div>
                        <h3>My Investments</h3>
                    </div>
                </div>
                <div className="row">
                    <div className="col-sm-3 col-md-4 my-3">
                        <div className="small-box">
                            <div className="inner text-center p-4">
                                <p className="invest">Investment Name</p>
                                <p>5%<small className="mx-2">Interest</small></p>
                                <div className="row" >
                                    <div className="col-sm-6">
                                        <p>N 5000<br/>
                                        <small>per unit</small></p>
                                    </div>
                                    <div className="col-sm-6">
                                        <p>50<br/>
                                        <small>Units</small></p>
                                    </div>
                                </div>
                                <Link to="#" className="p-4 small-box-footer">Invest</Link>
                            <Link to="#" className="p-4 small-box-footer">Details</Link>
                            </div>
                        </div>
                    </div>
                    <div className="col-sm-3 col-md-4  my-3">
                        <div className="small-box">
                        <div className="inner text-center p-4">
                                <p className="invest">Investment Name</p>
                                <p>5%<small className="mx-2">Interest</small></p>
                                <div className="row" >
                                    <div className="col-sm-6">
                                        <p>N 5000<br/>
                                        <small>per unit</small></p>
                                    </div>
                                    <div className="col-sm-6">
                                        <p>50<br/>
                                        <small>Units</small></p>
                                    </div>
                                </div>
                                <Link to="#" className="p-4 small-box-footer">Invest</Link>
                            <Link to="#" className="p-4 small-box-footer">Details</Link>
                            </div>
                        </div>
                    </div>
                    <div className="col-sm-3 col-md-4 my-3">
                        <div className="small-box">
                        <div className="inner text-center p-4">
                                <p className="invest">Investment Name</p>
                                <p>5%<small className="mx-2">Interest</small></p>
                                <div className="row" >
                                    <div className="col-sm-6">
                                        <p>N 5000<br/>
                                        <small>per unit</small></p>
                                    </div>
                                    <div className="col-sm-6">
                                        <p>50<br/>
                                        <small>Units</small></p>
                                    </div>
                                </div>
                                <Link to="#" className="p-4 small-box-footer">Invest</Link>
                            <Link to="#" className="p-4 small-box-footer">Details</Link>
                            </div>
                        </div>
                    </div>
                    <div className="col-sm-3 col-md-4 my-3">
                        <div className="small-box">
                        <div className="inner text-center p-4">
                                <p className="invest">Investment Name</p>
                                <p>5%<small className="mx-2">Interest</small></p>
                                <div className="row" >
                                    <div className="col-sm-6">
                                        <p>N 5000<br/>
                                        <small>per unit</small></p>
                                    </div>
                                    <div className="col-sm-6">
                                        <p>50<br/>
                                        <small>Units</small></p>
                                    </div>
                                </div>
                                <Link to="#" className="p-4 small-box-footer">Invest</Link>
                            <Link to="#" className="p-4 small-box-footer">Details</Link>
                            </div>
                        </div>
                    </div>
                    <div className="col-sm-3 col-md-4 my-3">
                        <div className="small-box">
                        <div className="inner text-center p-4">
                                <p className="invest">Investment Name</p>
                                <p>5%<small className="mx-2">Interest</small></p>
                                <div className="row" >
                                    <div className="col-sm-6">
                                        <p>N 5000<br/>
                                        <small>per unit</small></p>
                                    </div>
                                    <div className="col-sm-6">
                                        <p>50<br/>
                                        <small>Units</small></p>
                                    </div>
                                </div>
                                <Link to="#" className="p-4 small-box-footer">Invest</Link>
                            <Link to="#" className="p-4 small-box-footer">Details</Link>
                            </div>
                        </div>
                    </div>
                    <div className="col-sm-3 col-md-4 my-3">
                        <div className="small-box">
                        <div className="inner text-center p-4">
                                <p className="invest">Investment Name</p>
                                <p>5%<small className="mx-2">Interest</small></p>
                                <div className="row" >
                                    <div className="col-sm-6">
                                        <p>N 5000<br/>
                                        <small>per unit</small></p>
                                    </div>
                                    <div className="col-sm-6">
                                        <p>50<br/>
                                        <small>Units</small></p>
                                    </div>
                                </div>
                                <Link to="#" className="p-4 small-box-footer">Invest</Link>
                            <Link to="#" className="p-4 small-box-footer">Details</Link>
                            </div>
                        </div>
                    </div>
                    <div className="col-sm-3 col-md-4 my-3">
                        <div className="small-box">
                        <div className="inner text-center p-4">
                                <p className="invest">Investment Name</p>
                                <p>5%<small className="mx-2">Interest</small></p>
                                <div className="row" >
                                    <div className="col-sm-6">
                                        <p>N 5000<br/>
                                        <small>per unit</small></p>
                                    </div>
                                    <div className="col-sm-6">
                                        <p>50<br/>
                                        <small>Units</small></p>
                                    </div>
                                </div>
                                <Link to="#" className="p-4 small-box-footer">Invest</Link>
                            <Link to="#" className="p-4 small-box-footer">Details</Link>
                            </div>
                        </div>
                    </div>
                    <div className="col-sm-3 col-md-4 my-3">
                        <div className="small-box">
                        <div className="inner text-center p-4">
                                <p className="invest">Investment Name</p>
                                <p>5%<small className="mx-2">Interest</small></p>
                                <div className="row" >
                                    <div className="col-sm-6">
                                        <p>N 5000<br/>
                                        <small>per unit</small></p>
                                    </div>
                                    <div className="col-sm-6">
                                        <p>50<br/>
                                        <small>Units</small></p>
                                    </div>
                                </div>
                                <Link to="#" className="p-4 small-box-footer">Invest</Link>
                            <Link to="#" className="p-4 small-box-footer">Details</Link>
                            </div>
                           
                        </div>
                    </div>
                    <div className="col-sm-3 col-md-4 my-3">
                        <div className="small-box">
                        <div className="inner text-center p-4">
                                <p className="invest">Investment Name</p>
                                <p>5%<small className="mx-2">Interest</small></p>
                                <div className="row" >
                                    <div className="col-sm-6">
                                        <p>N 5000<br/>
                                        <small>per unit</small></p>
                                    </div>
                                    <div className="col-sm-6">
                                        <p>50<br/>
                                        <small>Units</small></p>
                                    </div>
                                </div>
                                <Link to="#" className="p-4 small-box-footer">Invest</Link>
                            <Link to="#" className="p-4 small-box-footer">Details</Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}